import classNames from "classnames";

import { ReactComponent as CheckMarkIcon } from "../../assets/icons/CheckmarkCircleFilled60.svg";
import { ReactComponent as InfoIconSvg } from "../../assets/icons/InfoFilled60.svg";
import { ReactComponent as LockIcon } from "../../assets/icons/Lock24.svg";
import { ReactComponent as ShaprLogo } from "../../assets/icons/ShaprLogoNoPadding.svg";
import { ReactComponent as WarningIconSvg } from "../../assets/icons/WarningIcon.svg";

import style from "./CompositeIcons.module.css";

export const SuccessIcon = () => (
  <div className={classNames(style.iconContainer, style.successIcon)}>
    <CheckMarkIcon className={style.icon} />
  </div>
);

export const WarningIcon = () => (
  <div className={classNames(style.iconContainer, style.warningIcon)}>
    <WarningIconSvg className={style.icon} />
  </div>
);

export const InfoIcon = () => (
  <div className={classNames(style.iconContainer, style.infoIcon)}>
    <InfoIconSvg className={style.icon} />
  </div>
);

export const PermissionIcon = () => (
  <div className={classNames(style.iconContainer, style.permissionIcon)}>
    <LockIcon className={style.icon} />
  </div>
);

export const ShaprLogoIcon = () => (
  <div className={classNames(style.iconContainer, style.logoIcon)}>
    <ShaprLogo className={style.icon} />
  </div>
);
